export const ROUTES = {
  BASE: '/',
  LTI_LAUNCH_REDIR:
    process.env.REACT_APP_ENV === 'development' ? '/:context/launch_redirect' : '/launch_redirect',
  AUTH_REDIRECT: '/auth_redirect',
  AUTH: '/auth',
  COURSE_APPROVAL: '/course/approval',
  COURSES: '/course/:section',
  COURSES_CREATE: '/create_course',
  COURSES_SELECT_CHILD: '/create_course/select_child',
  COURSE_MEMBERS: '/course/members',
  COURSE_SCORES: '/course/scores',
  COURSE_INSIGHTS: '/course/insights',
  COURSE_ATTENDANCE: '/course/attendance',
  COURSE_SETTINGS: '/course/settings',
  ADMIN: '/admin/:section', // `section` is indeed read from url params somewhere
  ADMIN_ACCOUNTS: '/admin/accounts',
  ADMIN_ACCOUNTS_FACULTY: '/admin/accounts/faculty',
  ADMIN_ACCOUNTS_STUDENTS: '/admin/accounts/students',
  ADMIN_COURSES: '/admin/courses',
  ADMIN_COURSES_SELECT: '/admin/courses/select',
  ADMIN_COURSES_CREATE: '/admin/courses/create',
  ADMIN_INSIGHTS: '/admin/insights',
  ADMIN_ATTENDANCE: '/admin/attendance',
  ADMIN_SETTINGS: '/admin/settings',
  LOG_OUT: '/logout',
  MESSAGE_PAGE: '/message',
};
